var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12109 16.6689C1.12109 10.0415 6.49368 4.66895 13.1211 4.66895H19.1211C25.7485 4.66895 31.1211 10.0415 31.1211 16.6689C31.1211 23.2964 25.7485 28.6689 19.1211 28.6689H1.12109V16.6689Z",
    fill: "url(#paint0_linear_1455_6822)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40234 16.2243C9.40234 16.2243 11.8468 11.3354 16.1246 11.3354C20.4023 11.3354 22.8468 16.2243 22.8468 16.2243C22.8468 16.2243 20.4023 21.1132 16.1246 21.1132C11.8468 21.1132 9.40234 16.2243 9.40234 16.2243Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1204 17.7521C17.133 17.7521 17.9538 16.9313 17.9538 15.9188C17.9538 14.9063 17.133 14.0854 16.1204 14.0854C15.1079 14.0854 14.2871 14.9063 14.2871 15.9188C14.2871 16.9313 15.1079 17.7521 16.1204 17.7521Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_6822",
    x1: 9.45443,
    y1: 6.00228,
    x2: 23.4544,
    y2: 28.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4665D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon2);
export default __webpack_public_path__ + "static/media/message_card_icon2.470523f76b007a35a412524e5027be5b.svg";
export { ForwardRef as ReactComponent };